import React from 'react'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

const TimetoGetPaid = (props) => {
    const parentDatas = props;
  return (
    <div className="card">
   <DataTable value={parentDatas.toGetPaid} tableStyle={{ minWidth: '100%' }}>
    <Column field="customerName" header="Customer Name" style={{width:"20%"}}></Column>
    <Column field="paymentWithin15Days" header="0 - 15 Days" 
        body={(data) => `${data.paymentWithin15Days} %`}>
    </Column>
    <Column field="payment16To30Days" header="16 - 30 Days" 
        body={(data) => `${data.payment16To30Days} %`}>
    </Column>
    <Column field="payment31To45Days" header="31 - 45 Days" 
        body={(data) => `${data.payment31To45Days} %`}>
    </Column>
    <Column field="paymentOver45Days" header="Above 45 Days" 
        body={(data) => `${data.paymentOver45Days} %`}>
    </Column>
</DataTable>

</div>
  )
}

export default TimetoGetPaid